export default __webpack_public_path__ + "static/media/ic_driver.6d0ab2f5.svg";